"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  accordionAnatomy: function accordionAnatomy() {
    return _accordionAnatomy;
  },
  alertAnatomy: function alertAnatomy() {
    return _alertAnatomy;
  },
  anatomy: function anatomy() {
    return _anatomy;
  },
  avatarAnatomy: function avatarAnatomy() {
    return _avatarAnatomy;
  },
  breadcrumbAnatomy: function breadcrumbAnatomy() {
    return _breadcrumbAnatomy;
  },
  buttonAnatomy: function buttonAnatomy() {
    return _buttonAnatomy;
  },
  cardAnatomy: function cardAnatomy() {
    return _cardAnatomy;
  },
  checkboxAnatomy: function checkboxAnatomy() {
    return _checkboxAnatomy;
  },
  circularProgressAnatomy: function circularProgressAnatomy() {
    return _circularProgressAnatomy;
  },
  drawerAnatomy: function drawerAnatomy() {
    return _drawerAnatomy;
  },
  editableAnatomy: function editableAnatomy() {
    return _editableAnatomy;
  },
  formAnatomy: function formAnatomy() {
    return _formAnatomy;
  },
  formErrorAnatomy: function formErrorAnatomy() {
    return _formErrorAnatomy;
  },
  inputAnatomy: function inputAnatomy() {
    return _inputAnatomy;
  },
  listAnatomy: function listAnatomy() {
    return _listAnatomy;
  },
  menuAnatomy: function menuAnatomy() {
    return _menuAnatomy;
  },
  modalAnatomy: function modalAnatomy() {
    return _modalAnatomy;
  },
  numberInputAnatomy: function numberInputAnatomy() {
    return _numberInputAnatomy;
  },
  pinInputAnatomy: function pinInputAnatomy() {
    return _pinInputAnatomy;
  },
  popoverAnatomy: function popoverAnatomy() {
    return _popoverAnatomy;
  },
  progressAnatomy: function progressAnatomy() {
    return _progressAnatomy;
  },
  radioAnatomy: function radioAnatomy() {
    return _radioAnatomy;
  },
  selectAnatomy: function selectAnatomy() {
    return _selectAnatomy;
  },
  sliderAnatomy: function sliderAnatomy() {
    return _sliderAnatomy;
  },
  statAnatomy: function statAnatomy() {
    return _statAnatomy;
  },
  stepperAnatomy: function stepperAnatomy() {
    return _stepperAnatomy;
  },
  switchAnatomy: function switchAnatomy() {
    return _switchAnatomy;
  },
  tableAnatomy: function tableAnatomy() {
    return _tableAnatomy;
  },
  tabsAnatomy: function tabsAnatomy() {
    return _tabsAnatomy;
  },
  tagAnatomy: function tagAnatomy() {
    return _tagAnatomy;
  }
});

module.exports = __toCommonJS(src_exports); // src/anatomy.ts

function _anatomy(name) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var called = false;

  function assert() {
    if (!called) {
      called = true;
      return;
    }

    throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
  }

  function parts() {
    assert();

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var part = _values[_i];
      ;
      map[part] = toPart(part);
    }

    return _anatomy(name, map);
  }

  function extend() {
    for (var _len2 = arguments.length, parts2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parts2[_key2] = arguments[_key2];
    }

    for (var _i2 = 0, _parts = parts2; _i2 < _parts.length; _i2++) {
      var part = _parts[_i2];
      if (part in map) continue;
      map[part] = toPart(part);
    }

    return _anatomy(name, map);
  }

  function selectors() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          part = _ref2[1];

      return [key, part.selector];
    }));
    return value;
  }

  function classnames() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          part = _ref4[1];

      return [key, part.className];
    }));
    return value;
  }

  function toPart(part) {
    var el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    var attr = el.filter(Boolean).join("__");
    var className = "chakra-".concat(attr);
    var partObj = {
      className: className,
      selector: ".".concat(className),
      toString: function toString() {
        return part;
      }
    };
    return partObj;
  }

  var __type = {};
  return {
    parts: parts,
    toPart: toPart,
    extend: extend,
    selectors: selectors,
    classnames: classnames,

    get keys() {
      return Object.keys(map);
    },

    __type: __type
  };
} // src/components.ts


var _accordionAnatomy = _anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");

var _alertAnatomy = _anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");

var _avatarAnatomy = _anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");

var _breadcrumbAnatomy = _anatomy("breadcrumb").parts("link", "item", "container").extend("separator");

var _buttonAnatomy = _anatomy("button").parts();

var _checkboxAnatomy = _anatomy("checkbox").parts("control", "icon", "container").extend("label");

var _circularProgressAnatomy = _anatomy("progress").parts("track", "filledTrack").extend("label");

var _drawerAnatomy = _anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");

var _editableAnatomy = _anatomy("editable").parts("preview", "input", "textarea");

var _formAnatomy = _anatomy("form").parts("container", "requiredIndicator", "helperText");

var _formErrorAnatomy = _anatomy("formError").parts("text", "icon");

var _inputAnatomy = _anatomy("input").parts("addon", "field", "element", "group");

var _listAnatomy = _anatomy("list").parts("container", "item", "icon");

var _menuAnatomy = _anatomy("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");

var _modalAnatomy = _anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");

var _numberInputAnatomy = _anatomy("numberinput").parts("root", "field", "stepperGroup", "stepper");

var _pinInputAnatomy = _anatomy("pininput").parts("field");

var _popoverAnatomy = _anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");

var _progressAnatomy = _anatomy("progress").parts("label", "filledTrack", "track");

var _radioAnatomy = _anatomy("radio").parts("container", "control", "label");

var _selectAnatomy = _anatomy("select").parts("field", "icon");

var _sliderAnatomy = _anatomy("slider").parts("container", "track", "thumb", "filledTrack", "mark");

var _statAnatomy = _anatomy("stat").parts("container", "label", "helpText", "number", "icon");

var _switchAnatomy = _anatomy("switch").parts("container", "track", "thumb", "label");

var _tableAnatomy = _anatomy("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");

var _tabsAnatomy = _anatomy("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");

var _tagAnatomy = _anatomy("tag").parts("container", "label", "closeButton");

var _cardAnatomy = _anatomy("card").parts("container", "header", "body", "footer");

var _stepperAnatomy = _anatomy("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number"); // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  accordionAnatomy: _accordionAnatomy,
  alertAnatomy: _alertAnatomy,
  anatomy: _anatomy,
  avatarAnatomy: _avatarAnatomy,
  breadcrumbAnatomy: _breadcrumbAnatomy,
  buttonAnatomy: _buttonAnatomy,
  cardAnatomy: _cardAnatomy,
  checkboxAnatomy: _checkboxAnatomy,
  circularProgressAnatomy: _circularProgressAnatomy,
  drawerAnatomy: _drawerAnatomy,
  editableAnatomy: _editableAnatomy,
  formAnatomy: _formAnatomy,
  formErrorAnatomy: _formErrorAnatomy,
  inputAnatomy: _inputAnatomy,
  listAnatomy: _listAnatomy,
  menuAnatomy: _menuAnatomy,
  modalAnatomy: _modalAnatomy,
  numberInputAnatomy: _numberInputAnatomy,
  pinInputAnatomy: _pinInputAnatomy,
  popoverAnatomy: _popoverAnatomy,
  progressAnatomy: _progressAnatomy,
  radioAnatomy: _radioAnatomy,
  selectAnatomy: _selectAnatomy,
  sliderAnatomy: _sliderAnatomy,
  statAnatomy: _statAnatomy,
  stepperAnatomy: _stepperAnatomy,
  switchAnatomy: _switchAnatomy,
  tableAnatomy: _tableAnatomy,
  tabsAnatomy: _tabsAnatomy,
  tagAnatomy: _tagAnatomy
});